import React from "react";
import ReactDOM from "react-dom";

import Main from "./Main";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";

ReactDOM.render(<Main />, document.getElementById("root"));
